/// <amd-module name="Reporting/Samples/VisualsSpecializedSamples" />
import * as React from "react";
import { Scalar } from "Reporting/Visuals/Scalar";
import { VssComponent } from "VSS/Platform/Layout";

export class VisualsSpecializedSamples extends VssComponent {
    public render(): JSX.Element {
        return (
            <article>
                <header>
                    <p>A collection of specialized visuals.</p>
                </header>
                <section>
                    <h1>Scalar</h1>
                    <p>
                        This component is located in <strong>reporting-visuals-scalar</strong>.
                    </p>
                    {this.renderExampleGrid("Examples", this.renderScalarExamples(), "one-by-one-layout")}
                    {this.renderExampleGrid("Contrast Ratio Examples", this.renderScalarColorContrastExamples(), "one-by-one-layout")}
                    {this.renderExampleGrid("Variable Font Size Examples", this.renderVariableFontSizeExamples(), "one-by-one-layout")}
                </section>
            </article>
        );
    }

    private renderScalarExamples(): JSX.Element[] {
        return [
            <Scalar title="Basic" subtitle="Work items" value={1} backgroundColor="#FF0000" />,
            <Scalar
                title="Click Handler"
                subtitle="Work items"
                value={4}
                backgroundColor="#00FF00"
                targetUrl="https://www.bing.com"
                targetUrlShouldUseNewTab
                onClick={() => window.alert("onClick fired!")}
            />
        ];
    }

    private renderScalarColorContrastExamples(): JSX.Element[] {
        const backgroundColors = ["#000000", "#444400", "#888800", "#BBBB00", "#FFFF00"];
        return backgroundColors.map(backgroundColor => (
            <Scalar title="Contrast" subtitle="Accessibility" value={5} backgroundColor={backgroundColor} />
        ));
    }

    private renderVariableFontSizeExamples(): JSX.Element[] {
        const values = [55, 555, 5555, 55555, 555555, 5555555, 55555555, 55555555555555];
        return values.map(value => (
            <Scalar title="Variable Font Size" subtitle={`${value.toString().length} digits`} value={value} backgroundColor="#FF8888" />
        ));
    }

    private renderExampleGrid(title: string, examples: JSX.Element[], exampleLayoutClassName: string): JSX.Element {
        return (
            <>
                <h3>{title}</h3>
                <div className="demo-visual-cell-grid">
                    {examples.map((example, index) => (
                        <div className={`demo-visual-cell ${exampleLayoutClassName}`} key={index}>
                            {example}
                        </div>
                    ))}
                </div>
            </>
        );
    }
}
